import { Outlet } from "react-router-dom";
import { ToastHost } from "../components/NotificationHost/NotificationHost";
import { useWithLtikSession } from "../hooks/use-with-ltik-session";
import { RouteTracker } from "../hooks/use-with-route-logging";
import type { RootOutletContext } from "../shared/outletContextsTypes";

export function RootLayout() {
  const { gradePosted, submittingGrade, isLtikSession, canvasId } =
    useWithLtikSession();

  const outletContext: RootOutletContext = {
    canvasId,
    submittingGrade,
    gradePosted,
    isLtikSession,
  };

  return (
    <>
      <ToastHost />
      <RouteTracker />
      <Outlet context={outletContext} />
    </>
  );
}
